"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterUpdateStandbyActivities = void 0;
const shift_create_standby_activity_1 = __importDefault(require("@app/request/shift-create-standby-activity"));
const shift_delete_standby_activity_1 = __importDefault(require("@app/request/shift-delete-standby-activity"));
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const FooterUpdateStandbyActivities = ({ details, close, standByActivities, originalStandByActivities, auth, workspaceId, }) => {
    if (!details)
        return null;
    return (react_1.default.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        } },
        react_1.default.createElement(_ui_1.Text, { type: 'body-small' },
            "DS ID: ",
            details.id),
        react_1.default.createElement("div", { style: { display: 'flex' } },
            react_1.default.createElement(_ui_1.Button, { label: (0, util_1.t)('CLOSE'), onClick: () => close() }),
            react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, color: _ui_1.Button.COLORS.GREEN, label: (0, util_1.t)('VIEW_SHIFT_SAVE_ACTIVITIES'), disabled: util_1.miscUtil.safeStringify(originalStandByActivities) ===
                    util_1.miscUtil.safeStringify(standByActivities), onClick: () => {
                    const updateActivities = async () => {
                        // if some existing activities were changed or removed, update or delete them (update is realized by deletion and addition of a new one)
                        const existingChildren = originalStandByActivities;
                        const toAdd = [];
                        const toRemove = [];
                        existingChildren.forEach((ec) => {
                            if (!standByActivities.find((sa) => sa.start === ec.start &&
                                sa.duration === ec.duration &&
                                sa.note === ec.note))
                                toRemove.push(ec);
                        });
                        standByActivities.forEach((sa) => {
                            if (!existingChildren.find((ec) => sa.start === ec.start &&
                                sa.duration === ec.duration &&
                                sa.note === ec.note))
                                toAdd.push(sa);
                        });
                        for (let i = 0; i < toRemove.length; i++) {
                            await (0, shift_delete_standby_activity_1.default)({
                                workspace: workspaceId,
                                shift: details.id,
                                activity: {
                                    start: toRemove[i].start,
                                    duration: toRemove[i].duration,
                                    note: toRemove[i].note,
                                },
                            }, auth);
                        }
                        for (let j = 0; j < toAdd.length; j++) {
                            await (0, shift_create_standby_activity_1.default)({
                                workspace: workspaceId,
                                shift: details.id,
                                activity: {
                                    start: toAdd[j].start,
                                    duration: toAdd[j].duration,
                                    note: toAdd[j].note,
                                },
                            }, auth);
                            util_1.notification.success({
                                code: 'standByActivityAdded',
                                message: undefined,
                            });
                        }
                        // reload the employee calendar if needed
                        if (window.reloadEmployeeCalendar &&
                            (toAdd.length || toRemove.length)) {
                            setTimeout(() => {
                                ;
                                window?.reloadEmployeeCalendar?.();
                            }, 500);
                        }
                    };
                    updateActivities()
                        .then(() => {
                        close();
                    })
                        .catch(() => { });
                } }))));
};
exports.FooterUpdateStandbyActivities = FooterUpdateStandbyActivities;
